import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { ToastContext } from 'app/context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { deleteAttachmentById, saveEmail, uploadAttachment } from 'app/api/emailMessageApi';
import { DataTable } from 'primereact/datatable';
import { SortOrder } from 'primereact/api';
import { Column } from 'primereact/column';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';
import { getAllLightCompanies } from 'app/api/insuranceCompanyApi';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { getAgentEmailAddresses } from 'app/api/agentApi';
import './mail-template.css';

const MailCompose = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [prilohy, setPrilohy] = useState([]);
  const [deleteDocument, setDeleteDocument] = useState(null);
  const [deleteDocumentDialog, setDeleteDocumentDialog] = useState(false);
  const [insuranceCompanies, setInsuranceCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [newMail, setNewMail] = useState(null);
  const fileUploadRef = useRef(null);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [emailOptions, setEmailOptions] = useState([]);

  useEffect(() => {
    getAllLightCompanies().then(response => {
      setInsuranceCompanies(
        response.data.map(company => ({
          label: company.name,
          value: company.id,
        })),
      );
    });

    getAgentEmailAddresses()
      .then(response => {
        const emails = response.data.map(client => ({ label: client.name + ' (' + client.email + ')', value: client.email }));

        setEmailOptions(emails);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      });
  }, []);

  const sendMail = () => {
    let tempMail = newMail;

    if (!tempMail) {
      tempMail = {};
    }

    tempMail.attachments = prilohy;

    if (selectedEmails?.length > 0) {
      tempMail.to = selectedEmails.join(';');
    } else {
      tempMail.to = '';
    }

    if (selectedCompany) {
      tempMail.insuranceCompany = { id: selectedCompany };
    }

    setLoading(true);

    saveEmail(tempMail)
      .then(response => {
        showSuccess('Úspech', 'E-mail úspešne odoslaný.');
        navigate(`/mail/inbox/${response.data?.id}`);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const goBack = () => {
    // navigate('/')
  };

  const handleAttachmentUpload = event => {
    const files = event.files;

    setLoading(true);
    uploadAttachment(files[0])
      .then(response => {
        if (prilohy) {
          setPrilohy(prev => [...prev, response.data]);
        } else {
          setPrilohy([response.data]);
        }
        if (fileUploadRef.current) {
          fileUploadRef.current.clear();
        }
        showSuccess('Úspech', 'Príloha bola úspešne pridaná.');
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const confirmDeleteContact = documentToDelete => {
    setDeleteDocumentDialog(true);
    setDeleteDocument(documentToDelete);
  };

  const handleDeleteDocument = () => {
    setLoading(true);

    deleteAttachmentById(deleteDocument?.id)
      .then(response => {
        setPrilohy(prevState => prevState.filter(p => p.id !== response.data));
        setDeleteDocumentDialog(false);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const deleteDocumentDialogFooter = (
    <React.Fragment>
      <Button label="Nie" icon="pi pi-times" outlined onClick={() => setDeleteDocumentDialog(false)} />
      <Button label="Áno" icon="pi pi-check" severity="danger" onClick={handleDeleteDocument} />
    </React.Fragment>
  );

  const actionBodyDocumentsTemplate = rowData => {
    return (
      <React.Fragment>
        <div className="flex justify-content-around">
          {/*{<Button icon="pi pi-download" type="button" rounded outlined className="mr-2" onClick={() => onDownloadDocument(rowData)} />}*/}
          {<Button icon="pi pi-trash" type="button" rounded outlined severity="danger" onClick={() => confirmDeleteContact(rowData)} />}
        </div>
      </React.Fragment>
    );
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-between">
        <FileUpload
          ref={fileUploadRef}
          mode="basic"
          multiple={false}
          accept=".csv,.xml,.pdf,.xlsx,.png,.jpg,.jpeg,.doc,.docx,.xls,.ppt,.pptx,.txt,.odt,.ods,.odp,.ics"
          auto={true}
          name="files"
          customUpload
          uploadHandler={handleAttachmentUpload}
          chooseLabel="Nahrať prílohu"
          uploadLabel="Nahrať"
          cancelLabel="Zrušiť"
        />{' '}
      </div>
    );
  };

  const header = renderHeader();

  const renderEditorHeader = () => {
    return (
      <span className="ql-formats">
        <button className="ql-header ql-picker"></button>
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
        <button className="ql-list" value="ordered" aria-label="Ordered list"></button>
        <button className="ql-align ql-picker ql-icon-picker ql-expanded" value="ordered" aria-label="Ordered list"></button>
        <button className="ql-link" value="ordered" aria-label="Insert link"></button>
      </span>
    );
  };

  const editorHeader = renderEditorHeader();

  return (
    <div className="card">
      <div className="grid" style={{ display: 'flex' }}>
        {/*<div className="w-full md:w-3 xl:w-2 xl:p-3">*/}
        {/*  <AppMailSidebar />*/}
        {/*</div>*/}
        <div className="md:w-12 xl:w-12 xl:p-3">
          <div className="flex align-items-center px-4 md:px-0 border-top-1 surface-border md:border-none pt-4 md:pt-0">
            <span className="block text-900 font-bold text-xl">Vytvoriť správu</span>
          </div>
          <div className="surface-section grid mt-4 grid-nogutter formgrid p-4 gap-3 md:surface-border md:border-1 border-round">
            <div className="col-12 field">
              <label htmlFor="to" className="text-900 font-semibold">
                Komu
              </label>
              <MultiSelect
                id="to"
                value={selectedEmails}
                options={emailOptions}
                className="custom-multiselect"
                onChange={e => setSelectedEmails(e.value)}
                placeholder="Vyberte agentov, ktorým sa E-mail pošle"
                filter
                display="chip"
                style={{ maxWidth: '95%' }}
              />
            </div>
            <div className="col-12 field">
              <label htmlFor="toAll" className="text-900 font-semibold">
                Poslať všetkým aktívnym poradcom
              </label>
              <span className="p-input-icon-left w-full" style={{ height: '3.5rem' }}>
                <Checkbox
                  id="toAll"
                  value={newMail?.toAll}
                  onChange={e => setNewMail(prevState => ({ ...prevState, toAll: e.checked }))}
                  className="w-full pl-7 text-900 font-semibold"
                  style={{ height: '3.5rem' }}
                  checked={newMail?.toAll}
                />
              </span>
            </div>
            <div className="col-12 field">
              <label htmlFor="insuranceCompany" className="text-900 font-semibold">
                Spoločnosť
              </label>
              <span className="p-input-icon-left w-full" style={{ height: '3.5rem' }}>
                <Dropdown
                  id="insuranceCompany"
                  name="insuranceCompany"
                  value={selectedCompany}
                  options={insuranceCompanies}
                  optionLabel="label"
                  filter
                  onChange={e => setSelectedCompany(e.value)}
                  placeholder="Vyberte si spoločnosť"
                />
              </span>
            </div>
            <div className="col-12 field">
              <label htmlFor="Subject" className="text-900 font-semibold">
                Predmet
              </label>
              <span className="p-input-icon-left w-full" style={{ height: '3.5rem' }}>
                <i className="pi pi-pencil" style={{ left: '1.5rem' }}></i>
                <InputText
                  id="subject"
                  value={newMail?.subject}
                  onChange={e =>
                    setNewMail(prevState => ({
                      ...prevState,
                      subject: e.target.value,
                    }))
                  }
                  placeholder="Predmet"
                  className="w-full pl-7 text-900 font-semibold"
                  style={{ height: '3.5rem' }}
                />
              </span>
            </div>
            <div className="col-12 field">
              <Editor
                style={{ height: '250px' }}
                value={newMail?.message}
                headerTemplate={editorHeader}
                onTextChange={e =>
                  setNewMail(prevState => ({
                    ...prevState,
                    message: e.htmlValue ?? '',
                  }))
                }
              ></Editor>
            </div>
            <div className="col-12">
              <DataTable
                stripedRows
                value={prilohy}
                size="small"
                dataKey="id"
                header={header}
                emptyMessage="Žiadne prílohy"
                sortField="id"
                sortOrder={SortOrder.DESC}
              >
                <Column field="originalFilename" header="Názov súboru" />
                <Column field="fileSize" header="Veľkosť" body={v => v?.fileSize / 1000 + ' KB'} />
                <Column body={actionBodyDocumentsTemplate} header="Akcie" exportable={false} style={{ justifyContent: 'end' }}></Column>
              </DataTable>
            </div>
            <div className="col-12 flex column-gap-3 justify-content-end">
              <Button type="button" className="h-3rem w-full sm:w-auto" icon="pi pi-send" label="Poslať správu" onClick={sendMail}></Button>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        visible={deleteDocumentDialog}
        style={{ width: '32rem' }}
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="Potvrdenie"
        modal
        footer={deleteDocumentDialogFooter}
        onHide={() => setDeleteDocumentDialog(false)}
      >
        <div className="confirmation-content">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
          {deleteDocument && (
            <span>
              Naozaj chcete vymazať prílohu: <b>{deleteDocument.originalFilename}</b>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default MailCompose;
